export default "__VITE_ASSET__j5ikn0Nx__"